/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect } from "react";

import Image from "next/image";
import Link from "next/link";

import MobileNavAccordionItem from "components/Shared/accordion/MobileNavAccordionItem";

import Close from "components/Shared/icons/close";
import SearchIcon from "components/Shared/icons/search";
import BurgerMenu from "components/Shared/icons/burger-menu";
import HeaderSearchPanel from "../HeaderSearchPanel";
import LanguagesDropdown_DGA from "./Components/languages-dropdown_DGA/LanguagesDropdown_DGA";

interface MobileNavProps {
  fields: any;
  locale: string;
  isSearchPanelOpen: boolean;
  setIsSearchPanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  unSupportedLocales?: string[];
  selectedHeaderNavItemsIds: any[];
}

const MobileNav = (props: MobileNavProps) => {
  const { fields, locale, isSearchPanelOpen, setIsSearchPanelOpen, unSupportedLocales } =
    props || {};
  const [isMobileNavOpen, setMobileNavOpen] = React.useState(false);

  useEffect(() => {
    const originalOverflow = document.body.style.overflow;

    if (typeof document === "undefined") return;

    if (isMobileNavOpen) {
      document.body.style.overflow = "hidden";
      (document.body.style as any).scrollbarGutter = "stable";
      document.body.style.height = "100vh";
    } else {
      document.body.style.overflow = originalOverflow;
      (document.body.style as any).scrollbarGutter = "auto";
      document.body.style.height = "auto";
    }

    return () => {
      document.body.style.overflow = originalOverflow;
      (document.body.style as any).scrollbarGutter = "auto";
      document.body.style.height = "auto";
    };
  }, [isMobileNavOpen]);


  const handleClickOnSearchIcon = () => {
    // Close mobile nav first, then toggle search panel
    if (isMobileNavOpen) {
      setMobileNavOpen(false);
    }
    setIsSearchPanelOpen((prev) => !prev);
  };

  const handleMobileNavToggle = () => {
    // Close search panel first, then toggle mobile nav
    if (isSearchPanelOpen) {
      setIsSearchPanelOpen(false);
    }
    setMobileNavOpen((prev) => !prev);
  };

  // Ensure mutual exclusivity: when search panel opens, close mobile nav
  useEffect(() => {
    if (isSearchPanelOpen && isMobileNavOpen) {
      setMobileNavOpen(false);
    }
  }, [isSearchPanelOpen, isMobileNavOpen]);

  // Ensure mutual exclusivity: when mobile nav opens, close search panel
  useEffect(() => {
    if (isMobileNavOpen && isSearchPanelOpen) {
      setIsSearchPanelOpen(false);
    }
  }, [isMobileNavOpen, isSearchPanelOpen, setIsSearchPanelOpen]);

  const langs = props?.fields?.Languages?.map((lang: any) => ({
    label: lang?.fields?.Title?.value,
    href: lang?.fields?.Code?.fields?.Iso?.value,
  }));

  return (
    <>
      <div className="flex items-center justify-between gap-4 py-2">
        {/* logo */}
        <Link href="/" locale={locale}>
          <a
            className="inline-flex rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-[#161616] focus-visible:ring-offset-2"
            aria-label={
              locale?.toLowerCase() === "ar"
                ? "الصفحة الرئيسية لوزارة الثقافة"
                : locale?.toLowerCase() === "zh"
                  ? "沙特阿拉伯文化部主页"
                  : locale?.toLowerCase() === "ko"
                    ? "사우디아라비아 문화부 홈"
                    : "Saudi Ministry of Culture home"
            }
          >
          <Image
            loading="eager"
            priority
            src={`/moc_logo_light.svg`}
            alt=""
            aria-hidden={true}
            width={93}
            height={60}
            className="cursor-pointer min-w-[93px] min-h-[60px]"
          />
          </a>
        </Link>

        {/* navigation burgur menu */}
        <button
          onClick={handleMobileNavToggle}
          aria-label={isMobileNavOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={isMobileNavOpen}
          className="flex items-center justify-center bg-neutral-100 hover:bg-neutral-200 active:bg-neutral-300 rounded p-[6px] transition-colors"
        >
          {isMobileNavOpen ? <Close /> : <BurgerMenu />}
        </button>
      </div>

      {isMobileNavOpen && (
        <div

          className={`absolute top-full h-[80vh] pb-28 left-0 right-0 pt-4  overflow-auto bg-[white] z-[9999]`}
        >
          <div className="max-w-[95%] mx-auto bg-[white] w-full">
            <nav
              aria-label={
                locale?.toLowerCase() === "ar"
                  ? "التنقل الرئيسي"
                  : locale?.toLowerCase() === "zh"
                  ? "主导航"
                  : locale?.toLowerCase() === "ko"
                  ? "주 메뉴"
                  : "Primary navigation"
              }
              className="bg-[white]"
            >
              {fields?.Links?.map((item: any) => (
                <MobileNavAccordionItem
                  selected={props?.selectedHeaderNavItemsIds?.includes(item.id)}
                  key={item.id}
                  item={item}
                />
              ))}
            </nav>

            {/* search and language buttons */}
            <div className="flex flex-col items-start w-full mt-16">
              {/* an array that includes both buttons, and their data */}
              {[
                {
                  title:
                    locale?.toLowerCase() === "en"
                      ? "Search"
                      : locale?.toLowerCase() === "zh"
                      ? "搜索"
                      : locale?.toLowerCase() === "ko"
                      ? "검색"
                      : "بحث",
                  icon: <SearchIcon color="#161616" classes="stroke-[#161616] w-4 h-4" aria-hidden={true} />,
                  activeButtonClasses: "!bg-primary-600 text-white",
                  activeHoverElementClasses: "visible !bg-primary-400",
                  onClick: handleClickOnSearchIcon,
                },
                // {
                //   title: "",
                //   icon: <LanguageIcon className="w-4 h-4" />,
                //   onClick: () => {
                //     // switchLocale(props)
                //   },
                // },
              ].map((buttonItem, index) => (
                // search and language buttons
                <button
                  type="button"
                  key={index}
                  onClick={buttonItem?.onClick}
                  className="w-full relative text-sm font-semibold px-4 py-2 flex items-center gap-2 mobile-nav-main-item-active"
                >
                  {buttonItem?.icon}
                  {buttonItem?.title}
                </button>
              ))}

              <LanguagesDropdown_DGA
                currentLocale={locale ?? "ar"}
                unSupportedLocales={unSupportedLocales ?? []}
                labels={{
                  trigger:
                    locale === "en"
                      ? "English"
                      : locale === "zh"
                      ? "Chinese"
                      : locale === "ko"
                      ? "Korean"
                      : "Arabic",
                  options: langs ?? [],
                }}
              />
            </div>
          </div>
        </div>
      )}

      {/* search and language buttons */}
      {/* search panel */}
      <HeaderSearchPanel
        SearchButtonText={props?.fields?.SearchButtonText?.value}
        SearchInputPlaceholder={props?.fields?.SearchInputPlaceholder?.value}
        SuggestionsHeader={props?.fields?.SuggestionsHeader?.value}
        SuggestionItems={props?.fields?.SuggestionItems}
        isSearchPanelOpen={isSearchPanelOpen && !isMobileNavOpen}
        setIsSearchPanelOpen={setIsSearchPanelOpen}
        locale={props?.locale}
      />
    </>
  );
};

export default MobileNav;
